import React from "react";

export default function CompHeader() {
  return (
    <div>
      <div
        className="card bg-danger text-white"
        style={{ borderRadius: "0px" }}
      >
        <div className="container my-4">
          <h3 className="card-title mt-5">Daftar Sebagai Member Karir</h3>
          <p className="card-text">
            Buran daftar sekarang juga, dapatkan bermain dengan team baru anda
          </p>
        </div>
      </div>
    </div>
  );
}
